<template>
  <div>
    <div
      class="border--solid border--complementary-50 border-radius-8 margin-bottom-8 padding-16 background-surface flex-between"
    >
      <span class="font-size-12 color-complementary-300">
        {{ item.caption }}
      </span>
      <MenuPopupWrapper
        iconClass="margin-right-8 color-complementary-200 cursor--pointer"
        menuClass="left-0 top-10 z-index-1 padding-top-24"
        :items="itemButtons"
        :permissions="permissions"
        :showMenu="currentItemMenuId === item.id"
        :rowItem="item"
        @click="handleOpenItemMenu"
        @close="handleCloseItemMenu"
      />
    </div>
    <Modal
      :show="isRemoveModal"
      :title="$lang.remove"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="true"
      size="sm"
      :okButton="true"
      okButtonVariant="filled-error"
      :okButtonText="$lang.delete"
      :ok="handleSubmitRemoveModal"
      @close="handleCloseRemoveModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.removeSureMessage }}
        </div>
      </template>
    </Modal>
    <EditPin
      :visible="isEditPin"
      :id="currentItemId"
      @handleClose="handleCloseEditPin"
    />
    <AttachmentSidebar
      :visible="isAttachmentSidebar"
      :id="currentItemId"
      :AddAttachmentSidebarWidth="700"
      wrapperClass="center-execute-activity-attachments"
      @handleClose="handleCloseAttachmentSidebar"
    />
  </div>
</template>

<script>
import { MenuPopupWrapper, Modal } from "@/components/re-design";
import EditPin from "./EditPin.vue";
import AttachmentSidebar from "./AttachmentSidebar.vue";
import { computed, inject, ref, toRefs } from "vue";
import { pathOr } from "ramda";
import { deleteActivity } from "@/services";
import { generateError, generateLang, toastAlert } from "@/shared/utils";
export default {
  components: { MenuPopupWrapper, Modal, EditPin, AttachmentSidebar },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // bind props
    const { item } = toRefs(props);

    // bind injects data
    const permissions = inject("PERMISSIONS");
    const resourceName = inject("RESOURCE_NAME");
    const resourceValue = inject("RESOURCE_VALUE");
    const handleReloadList = inject("handleReloadList");
    const isReadonly = inject("IS_READONLY");

    // handle edit
    const isEditPin = ref(false);
    const currentItemId = ref(null);
    const handleOpenEditPin = (item) => {
      const { id } = item;
      currentItemId.value = id;
      isEditPin.value = true;
    };
    const handleCloseEditPin = () => (isEditPin.value = false);

    // handle attachment sidebar
    const isAttachmentSidebar = ref(false);
    const handleOpenAttachmentSidebar = (item) => {
      const { id } = item;
      currentItemId.value = id;
      isAttachmentSidebar.value = true;
    };
    const handleCloseAttachmentSidebar = () =>
      (isAttachmentSidebar.value = false);

    // handle view
    const handleOpenViewPin = () => (isEditPin.value = true);

    // handle remove
    const isRemoveModal = ref(false);
    const handleOpenRemoveModal = () => (isRemoveModal.value = true);
    const handleCloseRemoveModal = () => (isRemoveModal.value = false);
    const handleSubmitRemoveModal = async () => {
      try {
        const { id } = item.value;
        const response = await deleteActivity(
          resourceName.value,
          resourceValue.value,
          id
        );
        const { message } = response;
        toastAlert(message);
        handleCloseRemoveModal();
        handleReloadList();
      } catch (error) {
        generateError(error);
      }
    };

    // handle menu items
    const currentItemMenuId = ref(null);
    const handleOpenItemMenu = (item) => {
      const id = pathOr(null, ["id"], item);
      currentItemMenuId.value = currentItemMenuId.value === id ? null : id;
    };
    const handleCloseItemMenu = () => (currentItemMenuId.value = null);
    // generate item buttons menu
    const itemButtons = computed(() => [
      {
        caption: isReadonly.value
          ? generateLang(["view"])
          : generateLang(["edit"]),
        icon: isReadonly.value ? "eye-outline" : "pencil-outline",
        show: true,
        permissions: ["admin", "edit"],
        click: handleOpenEditPin,
      },
      {
        caption: generateLang(["view"]),
        icon: "eye-outline",
        show: true,
        permissions: ["view"],
        click: handleOpenViewPin,
      },
      {
        caption: generateLang(["attachment"]),
        icon: "attachment",
        show: true,
        permissions: ["admin"],
        click: handleOpenAttachmentSidebar,
      },
      {
        caption: generateLang(["remove"]),
        icon: "trash-can-outline",
        show: !isReadonly.value,
        permissions: ["admin"],
        click: handleOpenRemoveModal,
      },
    ]);

    // return data to be used in template
    return {
      item,
      permissions,
      isEditPin,
      currentItemId,
      handleCloseEditPin,
      isRemoveModal,
      handleCloseRemoveModal,
      handleSubmitRemoveModal,
      currentItemMenuId,
      handleOpenItemMenu,
      handleCloseItemMenu,
      itemButtons,
      isAttachmentSidebar,
      handleCloseAttachmentSidebar,
    };
  },
};
</script>
